<template>

    <CRow>
        <CCol col="12" lg="10">
            <CCard>
                <CCardHeader>
                    <strong>{{ dish.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <CInput
                        v-model="modifierGroup.title"
                        label="Название группы"
                        placeholder="Введите название группы"
                    />
                    <CRow>
                        <CCol
                            tag="label"
                            class="col-form-label">Активен</CCol>
                        <CCol sm="10">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="modifierGroup.enabled"
                            />
                        </CCol>
                    </CRow>
                    <br><br>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <CCol sm="4">
                            <CSelect
                                horizontal
                                :options="modifiersOptions"
                                :value.sync="selectedModifier"
                                placeholder="Выберите модификатор..."
                            />
                        </CCol>
                        <CCol sm="8">
                            <CButton
                                color="primary"
                                class="ml-3"
                                @click="addModifier">Добавить</CButton>
                        </CCol>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <th>&nbsp;</th>
                                <th>Название</th>
                                <th>Цена</th>
                                <th>&nbsp;</th>
                            </thead>
                            <draggable v-model="modifiers" tag="tbody">
                                <tr v-for="modifier in modifiers" :key="modifier.title">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ modifier.title }}</td>
                                    <td>{{ modifier.price }}</td>
                                    <td><CButton @click="removeModifier(modifier.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton></td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create">Создать</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';

    export default {

        name: 'ModifiersGroupCreate',

        components: {
            draggable
        },

        icons: {
            cilCursorMove,
            cilTrash
        },
  
        data () {
            return {
                restaurant: {},
                dish: {},
                modifierGroup: {
                    title: '',
                    dish_id: '',
                    modifiers: [],
                    enabled: false,
                },
                modifiers: [],
                allModifiers: [],
                selectedModifier: null
            }
        },
    
        computed: {
            modifiersOptions: function() {
                const modifiersOptions = [];
                this.allModifiers.forEach(modifier => {
                    modifiersOptions.push({
                        value: modifier.id,
                        label: modifier.title + ' - ' + modifier.price + ' руб.'
                    });
                });
                return modifiersOptions;
            }
        },
  
        mounted() {
            const restaurantId = parseInt(this.$route.params.id);
            const id = parseInt(this.$route.params.dish_id);
            Vue.axios.get('/restaurants/' + restaurantId)
                .then(resp => {
                    this.restaurant = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get('/restaurants/' + restaurantId + '/dishes/' + id)
                .then(resp => {
                    this.dish = resp.data;
                    this.modifierGroup.dish_id = resp.data.id;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get('/restaurants/' + restaurantId + '/modifiers')
                .then(resp => {
                    this.setAllModifiers(resp.data);
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {

            create() {
                let index = 0;
                this.modifierGroup.enabled = this.modifierGroup.enabled;
                this.modifiers.forEach(modifier => {
                    modifier.position = ++index;
                    this.modifierGroup.modifiers.push(modifier.id);
                });
                Vue.axios.post(`/restaurants/${this.restaurant.id}/dishes/modifier-groups/${this.dish.id}`, this.modifierGroup)
                    .then(() => {
                        this.$router.push({ path: `/restaurants/${this.restaurant.id}/dishes/${this.dish.id}/modifier-groups` })
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            setAllModifiers(modifiers) {
                const _allModifiers = [];
                modifiers.forEach(modifier => {
                    if(this.addModifierOption(modifier.id)) {
                        _allModifiers.push({
                            id: modifier.id,
                            title: modifier.title,
                            price: modifier.price,
                            position: modifier.position
                        });
                    }
                });
                this.allModifiers = _allModifiers;
            },

            addModifierOption(id) {
                let contains = false;
                for(var i = 0; i < this.modifiers.length; i++) {
                    if(this.modifiers[i].id === id) {
                        contains = true;
                    }
                }
                return !contains;
            },

            addModifier() {
                for(var i = 0; i < this.allModifiers.length; i++) {
                    if(this.selectedModifier === this.allModifiers[i].id) {
                        this.modifiers.push({
                            id: this.allModifiers[i].id,
                            title: this.allModifiers[i].title,
                            price: this.allModifiers[i].price,
                            position: 0
                        });
                        delete this.allModifiers[i];
                        break;
                    }
                }
                this.setAllModifiers(this.allModifiers);
            },

            removeModifier(id) {
                const _modifiers = []; 
                for(var i = 0; i < this.modifiers.length; i++) {
                    if(id != this.modifiers[i].id) {
                        _modifiers.push(this.modifiers[i]);
                    }
                }
                this.modifiers = _modifiers;
            },

            goBack() {
                this.$router.push({ path: '/restaurants/' + this.restaurant.id + '/dishes/' + this.dish.id });
            }
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
